<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat outlined>
      <v-btn icon :link="false" @click="back">
        <v-icon>fa-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
      <v-spacer/>
      <v-btn color="primary" @click="send_form">
        Guardar
      </v-btn>
    </v-toolbar>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alertDialog"
        :type="alertDialogType"
        outline
      >
        {{ alertDialogMessage }}
      </v-alert>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos de Identificación</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm3 md3 style="display: none">
                <v-text-field
                  disabled
                  v-model="mascota_id"
                  label="id"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="nombre"
                  label="Nombre"
                  :rules="text_required_rules"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="especie"
                  label="Especie"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="raza"
                  label="Raza"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="sexo"
                  label="Sexo"
                />
              </v-flex>
              <FechaPicker
                v-model="fecha_nacimiento"
                label="Fecha Nacimiento"
                :clase="'my-0 py-0'">
              </FechaPicker>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="seguro_mascotas"
                  label="Seguro Responsabilidad Civil por Daños a Terceros"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="numero_chip"
                  label="Número Chip"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="carnet"
                  label="Carnet Vacunación o Pasaporte"
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-textarea class="my-0 py-0"
                  v-model="padecimientos"
                  label="Padecimientos"
                  no-resize
                  rows="1"
                  :value="padecimientos"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select class="my-0 py-0"
                  v-model="caracter"
                  label="Carácter"
                  :items="tipo_caracter"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select class="my-0 py-0"
                  v-model="profesion"
                  label="Tipo o Profesión"
                  :items="tipo_profesion"
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea class="my-0 py-0"
                  v-model="descripcion_fisica"
                  label="Descripción Física / Características"
                  no-resize
                  rows="2"
                  :value="descripcion_fisica"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>En caso de emergencia avisar a</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-text-field class="my-0 py-0"
                  v-model="emergencia_nombre"
                  label="Nombre Completo"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="emergencia_telefono"
                  label="Celular"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos del Responsable de la Mascota</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-combobox class="my-0 py-0"
                  v-model="vivienda_responsable_asoc"
                  label="Vivienda"
                  placeholder="Comience a escribir para buscar"
                  :items="viviendas_responsable"
                  :loading="viviendaIsLoading"
                  :search-input.sync="viviendaResponsableSearch"
                  :hide-no-data="!viviendaResponsableSearch"
                  item-text="n_vivienda"
                  item-value="n_vivienda"
                  return-object
                  @change="vivienda_asoc_change($event, 'responsable')"
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select class="my-0 py-0"
                  v-model="residente_responsable_asoc"
                  label="Residentes"
                  placeholder = "Seleccione un residente responsable"
                  no-data-text = "Vivienda sin residentes"
                  :items="residentes_responsable"
                  :disabled="residente_responsable_disabled"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos del Propietario de la Mascota</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-combobox class="my-0 py-0"
                  v-model="vivienda_propietario_asoc"
                  label="Vivienda"
                  placeholder="Comience a escribir para buscar"
                  :items="viviendas_propietario"
                  :loading="viviendaIsLoading"
                  :search-input.sync="viviendaPropietarioSearch"
                  :hide-no-data="!viviendaPropietarioSearch"
                  item-text="n_vivienda"
                  item-value="n_vivienda"
                  return-object
                  @change="vivienda_asoc_change($event, 'propietario')"
                  :rules="text_required_rules"
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select class="my-0 py-0"
                  v-model="residente_propietario_asoc"
                  label="Residentes"
                  placeholder = "Seleccione un residente propietario"
                  no-data-text = "Vivienda sin residentes"
                  :items="residentes_propietario"
                  :disabled="residente_propietario_disabled"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Fotos</strong>
                <v-divider/>
              </v-flex>
              <FotoSubir v-model="mascota_foto" :label="'Mascota'" :value="''"
                :size="'4'" :idImg="'imgFoto'"/>
              <FotoSubir v-model="mascota_foto_alt" :label="'Mascota'" :value="''"
                :size="'4'" :idImg="'imgFotoAlt'"/>
              <FotoSubir v-model="mascota_carnet" :label="'Carnet Veterinario o Pasaporte'" :value="''"
                :size="'4'" :idImg="'imgFotoCarnet'"/>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Aviso de Privacidad</strong>
                <v-divider/>
              </v-flex>
              <embed src="files/privacidad.pdf" type="application/pdf"
                width="100%" height="600px"/>
              <firma v-model="firma_responsable" :text_label="'Firma Responsable'"
                :id_canvas="'idResponsable'" :name_form="'formResponsable'"
                :name_sigraw="'sigRawResponsable'" :name_sigimg="'sigImgResponsable'">
              </firma>
              <firma v-model="firma_propietario" :text_label="'Firma Propietario'"
                :id_canvas="'idPropietario'" :name_form="'formPropietario'"
                :name_sigraw="'sigRawPropietario'" :name_sigimg="'sigImgPropietario'">
              </firma>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import FechaPicker from '@/components/fecha_picker.vue';
import FotoSubir from '@/components/foto_subir.vue';
import Firma from '@/components/firma.vue';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

export default {
  components: {
    FechaPicker,
    FotoSubir,
    Firma,
  },
  data: () => ({
    totalItems: 0,
    mascotas: [],
    pagination: {},
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    infodialog: false,
    tipo_caracter: [
      { text: 'Rojo: precaución', value: 'rojo' },
      { text: 'Naranja: no perros', value: 'naranja' },
      { text: 'Amarillo: nervioso/impredecible', value: 'amarillo' },
      { text: 'Verde: amistoso', value: 'verde' },
      { text: 'Azul: en entrenamiento o servicio', value: 'azul' },
      { text: 'Blanco: ciego o sordo', value: 'blanco' },
      { text: 'Morado: no alimentar', value: 'morado' },
    ],
    tipo_profesion: [
      { text: 'Domésticos', value: 'domesticos' },
      { text: 'Compañía', value: 'compania' },
      { text: 'Deportivos', value: 'deportivos' },
      { text: 'Adiestrado', value: 'adiestrados' },
      { text: 'Asistencia', value: 'asistencia' },
      { text: 'Espectáculos', value: 'espectaculos' },
      { text: 'Exhibición', value: 'exhibicion' },
      { text: 'Seguridad y Guarda', value: 'seguridad' },
      { text: 'Animaloterapía', value: 'animaloterapia' },
      { text: 'Silvestres', value: 'silvestres' },
      { text: 'Para venta', value: 'venta' },
    ],
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    img_rules: [
      v => !v || v.size < 2000000 || 'La imagen debe de ser menor a 2MB',
    ],
    valid: true,
    processing: false,
    mascota_id: '',
    nombre: '',
    especie: '',
    raza: '',
    sexo: '',
    fecha_nacimiento: '',
    seguro_mascotas: '',
    numero_chip: '',
    carnet: '',
    padecimientos: '',
    caracter: '',
    profesion: '',
    descripcion_fisica: '',
    emergencia_nombre: '',
    emergencia_telefono: '',
    vivienda_responsable: '',
    vivienda_responsable_asoc: '',
    residente_responsable: '',
    residente_responsable_asoc: '',
    vivienda_propietario: '',
    vivienda_propietario_asoc: '',
    residente_propietario: '',
    residente_propietario_asoc: '',
    mascota_foto: '',
    mascota_foto_alt: '',
    mascota_carnet: '',
    firma_responsable: [],
    firma_propietario: [],
    viviendaIsLoading: false,
    viviendaResponsableSearch: null,
    viviendaPropietarioSearch: null,
    viviendasResponsableApiResult: [],
    viviendasPropietarioApiResult: [],
    residentesResponsableApiResult: [],
    residentesPropietarioApiResult: [],
    residente_responsable_disabled: true,
    residente_propietario_disabled: true,
    editmascota: false,
    mascota_info: {},
  }),
  computed: {
    formTitle() {
      return this.editmascota === false ? 'Agregar Mascota' : 'Editar Mascota';
    },
    is_loading() {
      return this.$store.getters['capturaMascotas/is_loading'];
    },
    colaborador_submited() {
      return this.$store.getters['capturaMascotas/mascota_submited'];
    },
    alertType() {
      return this.$store.getters['capturaMascotas/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaMascotas/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaMascotas/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['capturaMascotas/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['capturaMascotas/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['capturaMascotas/alertDialog'];
    },
    mascota_processing() {
      return this.$store.getters['capturaMascotas/mascota_processing'];
    },
    viviendas_responsable() {
      return this.viviendasResponsableApiResult;
    },
    viviendas_propietario() {
      return this.viviendasPropietarioApiResult;
    },
    residentes_responsable() {
      return this.residentesResponsableApiResult;
    },
    residentes_propietario() {
      return this.residentesPropietarioApiResult;
    },
  },
  watch: {
    mascota_processing(val) {
      this.processing = val;
    },
    viviendaResponsableSearch() {
      // Items have already been loaded
      if (this.vivienda_responsable.length > 0) return;
      // Items have already been requested
      if (this.viviendaIsLoading) return;
      this.viviendaIsLoading = true;
      ApiService.setHeader();
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          this.viviendasResponsableApiResult = data.viviendas;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.viviendaIsLoading = false;
        });
    },
    viviendaPropietarioSearch() {
      // Items have already been loaded
      if (this.vivienda_propietario.length > 0) return;
      // Items have already been requested
      if (this.viviendaIsLoading) return;
      this.viviendaIsLoading = true;
      ApiService.setHeader();
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          this.viviendasPropietarioApiResult = data.viviendas;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.viviendaIsLoading = false;
        });
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
    vivienda_asoc_change(event, type) {
      if (type === 'responsable') {
        this.residente_responsable_disabled = false;
        this.residentesResponsableApiResult = [];
      } else if (type === 'propietario') {
        this.residente_propietario_disabled = false;
        this.residentesPropietarioApiResult = [];
      }
      this.redidenteIsLoading = true;
      if (typeof event === 'object' && this.clear_null(event) !== '') {
        // console.log(event.id !== undefined);
        ApiService.setHeader();
        ApiService.query(`accesos/viviendas/${event.id}`)
          .then(({ data }) => {
            if (data.vivienda.residentes.length > 0) {
              this.residente_concat_fullname(data.vivienda.residentes, type);
              if (type === 'responsable') {
                this.residente_responsable_asoc = data.vivienda.residentes[0].residente_id;
              } else if (type === 'propietario') {
                this.residente_propietario_asoc = data.vivienda.residentes[0].residente_id;
              }
            } else {
              console.log(data.vivienda);
            }
          })
          .catch(({ response }) => {
            console.log(response);
            if (type === 'responsable') {
              this.residente_responsable_disabled = true;
            } else if (type === 'propietario') {
              this.residente_propietario_disabled = true;
            }
          })
          .finally(() => {
            this.redidenteIsLoading = false;
          });
      } else if (type === 'responsable') {
        this.residente_responsable_disabled = true;
      } else if (type === 'propietario') {
        this.residente_propietario_disabled = true;
      }
    },
    vivienda_asoc_info(id, type) {
      ApiService.setHeader();
      ApiService.query(`accesos/viviendas/${id}`)
        .then(({ data }) => {
          if (type === 'responsable') {
            this.vivienda_responsable_asoc = data.vivienda;
          } else if (type === 'propietario') {
            this.vivienda_propietario_asoc = data.vivienda;
          }
          if (data.vivienda.residentes.length > 0) {
            this.residente_concat_fullname(data.vivienda.residentes, type);
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.redidenteIsLoading = false;
        });
    },
    residente_concat_fullname(info, type) {
      info.map((value, key) => {
        const tmpResult = {
          text: `${value.residente.nombres} ${this.clear_null(value.residente.apellido_paterno)} ${this.clear_null(value.residente.apellido_materno)}`.trim(),
          value: value.residente_id,
        };
        if (type === 'responsable') {
          this.residentesResponsableApiResult.push(tmpResult);
        } else if (type === 'propietario') {
          this.residentesPropietarioApiResult.push(tmpResult);
        }
      });
    },
    residente_asoc_info(id, type) {
      if (type === 'responsable') {
        this.residente_responsable_disabled = false;
        this.residentesResponsableApiResult = [];
      } else if (type === 'propietario') {
        this.residente_propietario_disabled = false;
        this.residentesPropietarioApiResult = [];
      }
      this.redidenteIsLoading = true;
      ApiService.setHeader();
      ApiService.query(`accesos/residentes/${id}`)
        .then(({ data }) => {
          if (type === 'responsable') {
            this.residente_responsable_asoc = data.residente.residente_id;
          } else if (type === 'propietario') {
            this.residente_propietario_asoc = data.residente.residente_id;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.redidenteIsLoading = false;
        });
    },
    decode_base64(value) {
      let encoded = '';
      let extension = '';
      if (value !== null) {
        encoded = value;
        const check = encoded.charAt(0);
        if (check === '/') {
          extension = 'jpg';
        } else if (check === '/') {
          extension = 'png';
        } else extension = 'tiff';
      } else {
        extension = 'png';
        encoded = 'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }

      return `data:image/${extension};base64,${encoded}`;
    },
    send_form() {
      if (this.processing === true) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.$store.commit('capturaMascotas/startedMascotaProcessing');
        const formdata = new FormData();
        formdata.set('nombre', this.clear_null(this.nombre));
        formdata.set('raza', this.clear_null(this.raza));
        formdata.set('especie', this.clear_null(this.especie));
        formdata.set('sexo', this.clear_null(this.sexo));
        formdata.set('seguro_mascotas', this.clear_null(this.seguro_mascotas));
        formdata.set('numero_chip', this.clear_null(this.numero_chip));
        formdata.set('carnet', this.clear_null(this.carnet));
        formdata.set('padecimientos', this.clear_null(this.padecimientos));
        formdata.set('caracter', this.caracter);
        formdata.set('profesion', this.profesion);
        formdata.set('descripcion_fisica', this.clear_null(this.descripcion_fisica));
        formdata.set('emergencia_nombre', this.clear_null(this.emergencia_nombre));
        formdata.set('emergencia_telefono', this.clear_null(this.emergencia_telefono));
        if (this.fecha_nacimiento !== '') {
          formdata.set('fecha_nacimiento', this.clear_null(this.fecha_nacimiento));
        }
        let tmpViviendaResponsable = '';
        if (typeof this.vivienda_responsable_asoc === 'object' && this.clear_null(this.vivienda_responsable_asoc) !== '') {
          tmpViviendaResponsable = this.vivienda_responsable_asoc.id;
        } else {
          tmpViviendaResponsable = this.clear_null(this.vivienda_responsable_asoc);
        }
        if (tmpViviendaResponsable !== '') {
          formdata.set('vivienda_responsable_id', tmpViviendaResponsable);
          formdata.set('residente_responsable_id', this.residente_responsable_asoc);
        }
        if (typeof this.vivienda_propietario_asoc === 'object' && this.clear_null(this.vivienda_propietario_asoc) !== '') {
          formdata.set('vivienda_propietario_id', this.vivienda_propietario_asoc.id);
        } else {
          formdata.set('vivienda_propietario_id', this.clear_null(this.vivienda_propietario_asoc));
        }
        formdata.set('residente_propietario_id', this.residente_propietario_asoc);
        if (this.mascota_foto.length !== 0) {
          if (this.mascota_foto.includes('base64')) {
            formdata.set('mascota_foto', this.mascota_foto.split(',')[1]);
          } else {
            formdata.set('mascota_foto', this.mascota_foto);
          }
        }
        if (this.mascota_foto_alt.length !== 0) {
          if (this.mascota_foto_alt.includes('base64')) {
            formdata.set('mascota_foto_alt', this.mascota_foto_alt.split(',')[1]);
          } else {
            formdata.set('mascota_foto_alt', this.mascota_foto_alt);
          }
        }
        if (this.mascota_carnet.length !== 0) {
          if (this.mascota_carnet.includes('base64')) {
            formdata.set('mascota_carnet', this.mascota_carnet.split(',')[1]);
          } else {
            formdata.set('mascota_carnet', this.mascota_carnet);
          }
        }
        if (this.firma_responsable.length !== 0) {
          formdata.set('firma_responsable', this.firma_responsable[this.firma_responsable.length - 1]);
        }
        if (this.firma_propietario.length !== 0) {
          formdata.set('firma_propietario', this.firma_propietario[this.firma_propietario.length - 1]);
        }
        if (this.editmascota) {
          formdata.set('mascota_id', this.mascota_id);
        }

        // console.log(Object.fromEntries(formdata));
        this.$store.commit('capturaMascotas/resetMascotaSubmit');
        if (this.editmascota) {
          this.$store.dispatch('capturaMascotas/editMascota', formdata).then(() => {
            this.$router.back();
          });
        } else {
          this.$store.dispatch('capturaMascotas/sendMascota', formdata).then(() => {
            this.$router.back();
          });
        }
      }
    },
    init_edit_data(data) {
      this.mascota_id = data.id;
      this.nombre = data.nombre;
      this.especie = data.especie;
      this.raza = data.raza;
      this.sexo = data.sexo;
      this.fecha_nacimiento = this.clear_null(data.fecha_nacimiento);
      this.seguro_mascotas = data.seguro_mascotas;
      this.numero_chip = data.numero_chip;
      this.carnet = data.carnet;
      this.padecimientos = data.padecimientos;
      this.caracter = data.caracter;
      this.profesion = data.profesion;
      this.descripcion_fisica = data.descripcion_fisica;
      this.emergencia_nombre = data.emergencia_nombre;
      this.emergencia_telefono = data.emergencia_telefono;
      if (data.vivienda_responsable_id !== null) {
        this.vivienda_asoc_info(data.vivienda_responsable_id, 'responsable');
        this.residente_asoc_info(data.residente_responsable_id, 'responsable');
      }
      if (data.vivienda_propietario_id !== null) {
        this.vivienda_asoc_info(data.vivienda_propietario_id, 'propietario');
        this.residente_asoc_info(data.residente_propietario_id, 'propietario');
      }
      if (data.mascota_foto_b64 !== null) {
        this.mascota_foto = data.mascota_foto_b64;
        const imageToShow = document.getElementById('imgFoto');
        imageToShow.src = this.decode_base64(data.mascota_foto_b64);
      }
      if (data.mascota_foto_alt_b64 !== null) {
        this.mascota_foto_alt = data.mascota_foto_alt_b64;
        const imageToShow = document.getElementById('imgFotoAlt');
        imageToShow.src = this.decode_base64(data.mascota_foto_alt_b64);
      }
      if (data.mascota_carnet_b64 !== null) {
        this.mascota_carnet = data.mascota_carnet_b64;
        const imageToShow = document.getElementById('imgFotoCarnet');
        imageToShow.src = this.decode_base64(data.mascota_carnet_b64);
      }
      // console.log(data);
    },
  },
  created() {
  },
  mounted() {
    if ('id' in this.$route.params) {
      this.$store.dispatch('capturaMascotas/fetchMascotaInfo', this.$route.params.id).then((data) => {
        // this.mascota_info = data;
        this.init_edit_data(data.mascota);
      });
      this.editmascota = true;
    }
  },
};
</script>
<style type="text/css">

</style>
